import { BoundedContent, Box, Column, GridContainer, Link, Row, Typography } from '@vp/swan';
import { scrollToElementById } from '@99designs/browser';
import {
    IconTextPair,
    SvgFeedbackAndRevision,
    SvgFilesReady,
    SvgFindADesigner,
    SvgReceiveInvoice,
} from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import { FeaturedProductsId } from '../FeaturedProducts/FeaturedProducts';

export const HowItWorksId = 'how-it-works';

interface HowItWorksItem {
    copy: React.ReactNode;
    icon: React.ReactNode;
}

export function HowItWorks() {
    const howItWorksItems: HowItWorksItem[] = [
        {
            copy: (
                <>
                    <Link
                        onClick={() => {
                            scrollToElementById(FeaturedProductsId);
                        }}
                        mr={'2'}
                    >
                        {__('Choose a product')}
                    </Link>
                    {__('based on your unique needs.')}
                </>
            ),
            icon: <SvgFindADesigner />,
        },
        {
            copy: __('Fill out a brief and share your project details with your designer.'),
            icon: <SvgReceiveInvoice />,
        },
        {
            copy: __('Work with your designer on feedback and revisions.'),
            icon: <SvgFeedbackAndRevision />,
        },
        {
            copy: __('Your designer will provide you with files ready to print.'),
            icon: <SvgFilesReady />,
        },
    ];

    return (
        <Box id={HowItWorksId} data-testid={HowItWorksId} mt={10}>
            <BoundedContent>
                <Box marginBottom="between-subsections">
                    <Typography fontSkin="title-section" textAlign="center" as="h2">
                        {__('Collaborate with a designer')}
                    </Typography>
                    <Typography
                        fontSkin="body-standard"
                        textAlign="center"
                        fontWeight="normal"
                        as="h3"
                    >
                        {__(
                            "Getting professional design has never been easier. Here's how it's done:"
                        )}
                    </Typography>
                </Box>
                <GridContainer>
                    <Row>
                        {howItWorksItems.map(({ copy, icon }, index) => {
                            const isFirstElement = index === 0;

                            return (
                                <Column
                                    key={`how-it-works-${index}`}
                                    span={2}
                                    spanSm={3}
                                    offsetSm={0}
                                    offset={isFirstElement ? 2 : 0}
                                >
                                    <IconTextPair text={copy} icon={icon} />
                                </Column>
                            );
                        })}
                    </Row>
                </GridContainer>
                <Box textAlign="center" mt="between-subsections">
                    <Link
                        skin="cta"
                        onClick={() => {
                            scrollToElementById(FeaturedProductsId);
                        }}
                    >
                        {__('Choose a product to get started')}
                    </Link>
                </Box>
            </BoundedContent>
        </Box>
    );
}
